import React from "react";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { range } from "lodash";
import { LocalForm, Control, actions } from "react-redux-form";
import { formatDate } from "services/util";
import moment from "moment";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";

import Select from "react-select";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import { ReportContainer } from "./components";

export const BudgetSummary = ({
  data,
  item,
  handleSubmit,
  periods,
  timeframes,
  setState,
  t
}) => (
   
  <Page title={data.ReportTitles[0]} translate={false}>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="Date" className="mr-3">
          <DatePicker model=".date" className="form-control" />
        </FormGroup>
        <FormGroup label="Periods" className="mr-3" addControlClass={false}>
          <Control.select
            component={Select}
            simpleValue
            style={{ minWidth: "10rem", backgroundColor:'#F4F7FE'}}
            options={periods}
            searchable={false}
            model=".periods" 
            placeholder={t('Select...')}
          />
        </FormGroup>
        <FormGroup label="Timeframe" className="mr-3" addControlClass={false}>
          <Control.select
            component={Select}
            simpleValue
            style={{ minWidth: "10rem", backgroundColor:'#F4F7FE'}}
            options={timeframes}
            searchable={false}
            model=".timeframe" 
            placeholder={t('Select...')}
          />
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>
    <ReportContainer report={data} />
  </Page>
);

const loadReport = (item, xero) =>
  xero
    .get("reports/BudgetSummary", {
      params: {
        extra_params: item,
      },
    })
    .get("data");

export const enhance = compose(
  onMount(({ xero }) => () => {
    const item = {};

    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),

  withDefaultReportParams(() => ({
    date: formatDate(moment().startOf("year")),
    periods:1,
    timeframe:1
  })),

  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 12 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      [1, t("Month")],
      [3, t("Quarter")],
      [12, t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch }) =>
      (item) => {
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(BudgetSummary);
